import { CampaignControlOptionApiGroup } from '@/Enums/ControlOptions/CampaignGroup.enum';
import { IGroupedControlOption } from '@/Interfaces/ControlOption.interface';
import { IDv360InsertionOrder } from '@/Interfaces/DV360/InsertionOrder.interface';
import { IPacingReportRecord } from '@/Interfaces/Pacing/ReportRecord.interface';
import { RootState } from '@/store';
import { AsyncThunkPayloadCreator } from '@reduxjs/toolkit';
import axios from 'axios';
import { mapGroupedGoogleCampaigns } from '../google/campaigns';
import { getPacingFilters } from './slice';

const API_ENDPOINTS = {
  REPORT: '/pacing/google/report',
  CAMPAIGNS: '/pacing/google/campaigns',
};

export const googlePacingReportHandler: AsyncThunkPayloadCreator<
  IPacingReportRecord[],
  { signal?: AbortSignal }
> = async (payload, { getState }) => {
  const state = getState() as RootState;

  const apiFilter = getPacingFilters(state, CampaignControlOptionApiGroup.Google);

  if (!apiFilter.advertiserIds?.length && !apiFilter.campaignIds?.length) {
    console.error('No advertisers for pacing reports filters.');
    return [];
  }

  const responseResult = await axios.post(API_ENDPOINTS.REPORT, { filters: apiFilter }, { signal: payload.signal });
  return responseResult.data;
};

export const getGoogleCampaignFilterOptions = async (
  ribeyeAdvertiserIds: number[],
): Promise<IGroupedControlOption[]> => {
  if (!ribeyeAdvertiserIds?.length) {
    return [];
  }

  const response = await axios.post<IDv360InsertionOrder[]>(API_ENDPOINTS.CAMPAIGNS, {
    advertiserIds: ribeyeAdvertiserIds,
  });

  return mapGroupedGoogleCampaigns(response.data ?? []);
};
